import { flatten } from "../../flatten";
/**
 * Validates that a date is not after a maximum date.
 */
export const Validator = {
    name: "max_date",
    isImplicit: false,
    errorMessage: "This date must be before :max_date.",
    validate: function (value, requirement) {
        const [dateField, maxDateField] = requirement.split(",");
        // TODO: write a test and refactor
        const dateVal = flatten(this.validator.input)[dateField];
        const maxDateVal = flatten(this.validator.input)[maxDateField];
        return Number(new Date(dateVal)) >= Number(new Date(maxDateVal));
    },
};
